import { Flex, Text } from "@chakra-ui/react";
import React from "react";

const Catalog = () => {
  return (
    <Flex align="center" justify="center" bg="gray" color="white" h="100vh">
      <Text fontSize="3xl">Catalog</Text>
    </Flex>
  );
};

export default Catalog;
